import React from "react";
import NodePorts from "./NodePorts";
import { Handle, Position } from "react-flow-renderer";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { Input } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  nodeContainer: {
    minWidth: 200,
    maxWidth: 280,
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    background: "linear-gradient(135deg, #9C27B0 0%, #E91E63 100%)",
    boxShadow: "0 4px 12px rgba(156, 39, 176, 0.4)",
    border: "2px solid #9C27B0",
    color: "white",
    position: "relative",
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 16px rgba(156, 39, 176, 0.5)",
    },
  },
  nodeHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  nodeIcon: {
    fontSize: 20,
  },
  nodeLabel: {
    fontWeight: 600,
    fontSize: 14,
    color: "white",
  },
  nodeContent: {
    fontSize: 12,
    opacity: 0.95,
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(1),
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderRadius: 8,
    maxHeight: 100,
    overflow: "hidden",
    textOverflow: "ellipsis",
    wordBreak: "break-word",
  },
  handle: {
    width: 12,
    height: 12,
    background: "white",
    border: "2px solid #9C27B0",
    borderRadius: "50%",
  },
}));

// Regla de validación del nodo (0422 R3), visible en el lienzo sin abrirlo.
const ETIQUETA_VALIDACION = {
  digitos: "solo dígitos", numero: "número", email: "correo", telefono: "teléfono", fecha: "fecha", url: "enlace",
};

const InputNode = ({ data, selected }) => {
  const classes = useStyles();
  const messageText = data?.message || data?.label || "Esperando input";

  return (
    <Box
      className={classes.nodeContainer}
      style={{
        boxShadow: selected
          ? "0 6px 20px rgba(156, 39, 176, 0.6)"
          : "0 4px 12px rgba(156, 39, 176, 0.4)",
      }}
    >
      <NodePorts color="#9C27B0" />
      <Box className={classes.nodeHeader}>
        <Input className={classes.nodeIcon} />
        <Typography className={classes.nodeLabel}>Input</Typography>
      </Box>
      <Box className={classes.nodeContent}>
        {messageText.length > 50 ? `${messageText.substring(0, 50)}...` : messageText}
      </Box>
      {/* Tope de intentos (0422): al agotarlos, el flujo sale por aquí (p. ej. a un agente). */}
      {Number(data?.maxAttempts) > 0 && (
        <Handle
          type="source"
          position={Position.Right}
          id="agotado"
          title="Sin respuesta válida tras agotar los intentos"
          style={{ top: "75%", right: -6, width: 12, height: 12, background: "#e53935", border: "2px solid #fff" }}
        >
          <Box style={{ position: "absolute", left: 14, top: -8, fontSize: 10, fontWeight: 600, color: "#e53935",
            background: "white", padding: "1px 5px", borderRadius: 4, whiteSpace: "nowrap", pointerEvents: "none" }}>
            sin respuesta válida
          </Box>
        </Handle>
      )}
      {data?.validation && data.validation !== "texto" && (
        <Box style={{ fontSize: 11, opacity: 0.85, marginTop: 4 }}>
          ✓ valida: {ETIQUETA_VALIDACION[data.validation] || data.validation}
          {Number(data?.maxAttempts) > 0 ? ` · máx. ${data.maxAttempts} intentos` : ""}
        </Box>
      )}
    </Box>
  );
};

export default InputNode;
